

export default {
    props: {
        value: {
            type: Boolean,
            required: false
        },
        employee: {
            type: Object,
            required: false
        },
    },
    components: {
    },
    created() {
        let t = this;
    },
    activated() {
        let t = this;
    },
    methods: {

        close() {
            this.$emit('input', false);
        },

        savePwd() {
            let t = this;

            let f = t.f;

            if (!t.employee) {
                if (!f.old_password) {
                    A.err('旧パスワードを入力してください');
                    return;
                }
            }

            if (!f.new_password) {
                A.err('新しいパスワードを入力してください');
                return;
            }

            if (f.new_password != f.confirmed_password) {
                A.err('新しいパスワードが一致していません');
                return;
            }

            if (t.employee) {
                f.employee_id = t.employee.id;
            }

            axios.post('employee/savePassword', f).then(res => {
                if (res.data.status == 1) {

                    if (!t.employee) {
                        A.show('変更が成功しました。アカウントを再度ログインしてください。', 'パスワードが変更されました。', 'success').then(res => {
                            localStorage.removeItem('_m');
                            location.reload('/#/employee');
                        });
                    }
                    else {
                        A.show('変更が成功。', 'パスワードが変更されました。', 'success');
                        t.close();
                    }

                }
                else if (res.data.status == 2) {
                    A.err('旧パスワードが正しくありません');
                }
            });

        }

    },
    data() {
        return {

            f: {
                old_password: '',
                new_password: '',
                confirmed_password: '',
            },

        };
    },
    computed: {},
};
